module.exports = __webpack_public_path__ + "KaTeX_Main-Bold.80e749e9.ttf";